import React from 'react';
import { observer } from 'mobx-react-lite';
import { Message, Icon, Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { useStore } from '../../../app/stores/store';
import CourtListItem from './CourtListItem';
import { AvailableCourtSlotDTO, TimeSlot } from '../../../app/models/AvailableCourtSlots';
import { PagingParams } from '../../../app/models/Pagination';


interface Props {
    userLat: number;
    userLng: number;
    onSlotSelect?: (slot: AvailableCourtSlotDTO, timeSlot: TimeSlot) => void;
}

export default observer(function CourtList({ userLat, userLng, onSlotSelect }: Props) {
    const { t } = useTranslation();
    const { courtStore } = useStore();
    const { courtSlots, pagination, loadingCourts, loadCourts, setPagingParams } = courtStore;

    const handleLoadMore = () => {
        if (loadingCourts || !pagination) return;
        if (pagination.currentPage >= pagination.totalPages) return;
        setPagingParams(new PagingParams(pagination.currentPage + 1));
        loadCourts(userLat, userLng, false);
    };

    if (courtSlots.length === 0 && !loadingCourts) {
        return (
            <Message info icon>
                <Icon name='search' />
                <Message.Content>
                    <Message.Header>{t('courts.list.empty.title')}</Message.Header>
                    {t('courts.list.empty.message')}
                </Message.Content>
            </Message>
        );
    }

    return (
        <>
            <InfiniteScroll
                pageStart={0}
                loadMore={handleLoadMore}
                hasMore={
                    !loadingCourts &&
                    !!pagination &&
                    pagination.currentPage < pagination.totalPages
                }
                initialLoad={false}
            >
                {courtSlots.map((slot, index) => (
                    <CourtListItem
                        key={`${slot.companySportVenueAssetId}-${index}`}
                        slot={slot}
                        onSlotSelect={onSlotSelect}
                    />
                ))}
            </InfiniteScroll>

            {/* Inline loader for subsequent pages */}
            {loadingCourts && !courtStore.loadingInitial && (
                <Loader active inline='centered' style={{ marginTop: '20px' }} />
            )}
        </>
    );
});